import * as React from "react";
const SvgLaundryWm = (props) => /* @__PURE__ */ React.createElement("svg", {
	id: "Ebene_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 31 31",
	style: { enableBackground: "new 0 0 31 31" },
	xmlSpace: "preserve",
	...props
}, /* @__PURE__ */ React.createElement("style", { type: "text/css" }, "\n	.st0{fill:none;stroke:#CE0F69;stroke-width:2.5;stroke-linecap:square;stroke-opacity:0.87;}\n	.st1{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:2;stroke-linecap:square;}\n"), /* @__PURE__ */ React.createElement("path", {
	className: "st0",
	d: "M28,1H10v22h18V1z"
}), /* @__PURE__ */ React.createElement("path", {
	className: "st0",
	d: "M25,4h-3"
}), /* @__PURE__ */ React.createElement("path", {
	className: "st0",
	d: "M12,18v-6"
}), /* @__PURE__ */ React.createElement("path", {
	className: "st0",
	d: "M28,8H10"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 4,
	y: 7,
	className: "st1",
	width: 18,
	height: 22
}), /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", {
	className: "st0",
	d: "M21,8H3v22h18V8z"
}), /* @__PURE__ */ React.createElement("path", {
	className: "st0",
	d: "M18,11h-3"
}), /* @__PURE__ */ React.createElement("path", {
	className: "st0",
	d: "M7.2,24.8C8.7,25.6,10.4,26,12,26s3.3-0.4,4.8-1.2c0.8-1.5,1.2-3.1,1.2-4.8c0-1.6-0.5-3.3-1.2-4.8 C15.3,14.4,13.7,14,12,14c-1.6-0.1-3.3,0.4-4.8,1.2C6.4,16.7,6,18.4,6,20C6,21.7,6.4,23.3,7.2,24.8z"
}), /* @__PURE__ */ React.createElement("circle", {
	className: "st0",
	cx: 12,
	cy: 20,
	r: 3
})), /* @__PURE__ */ React.createElement("path", {
	className: "st0",
	d: "M18,11h-3"
}), /* @__PURE__ */ React.createElement("path", {
	className: "st0",
	d: "M18,11h-3"
}));
export default SvgLaundryWm;
